import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function MooAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <polygon
        fill="#fff"
        points="56.7 81.52 56.7 111.25 49.44 106.79 49.44 52.24 42.52 56.46 42.52 102.52 35.25 98.08 35.26 52.01 70.99 30 70.98 120 63.73 115.6 63.73 43.47 56.7 47.75 56.7 79.39 56.72 80.57 56.7 81.52"
      />
      <path
        fill="#fff"
        d="M114.74,79.48h-35.37c-.21.07-.36.22-.36.46v9.05c2.24,1.97,3.66,4.85,3.66,8.07s-1.42,6.1-3.66,8.07v14.87s35.73-20.63,35.73-20.63v-19.89ZM86.29,107.4l-.02-20.22c0-.32.24-.48.55-.45h20.65s.02,8.43.02,8.43l-21.2,12.24Z"
      />
      <path
        fill="#fff"
        d="M79.02,30.02v14.86c2.24,1.97,3.65,4.85,3.65,8.07s-1.42,6.1-3.66,8.07v9.15c.07.23.22.37.45.37h35.27s0-19.9,0-19.9l-35.73-20.63ZM107.48,63.28h-20.44c-.35,0-.56,0-.77-.26l.02-20.41,21.2,12.24v8.44Z"
      />
    </svg>
  );
}
